/* eslint-disable no-new */
import { SearchDropdownToggleVisibility } from "./search-dropdown-toggle-visibility-class";
import { SearchDropdownFilter } from "./search-dropdown-filter-class";

export default () => {
  new SearchDropdownToggleVisibility({
    event: "focusin",
    eventSelector: ".js-masthead-search-form",
    dropdownSelector: ".js-masthead-search-dropdown",
    iconSelector: ".js-masthead-search-submit-icon"
  });

  new SearchDropdownFilter({
    formSelector: ".js-masthead-search-form",
    eventSelector: ".js-masthead-search-dropdown-button"
  });
};
